export * from "./vertical-feature-card.component";
